import { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useGetDeliveryPartnerDocumentsQuery } from "../../slices/usersApiSlice";
import { useUploadDeliveryPartnerDocumentsMutation } from "../../slices/filesApiSlice";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";

const DeliveryPartnerDocumentsScreen = () => {
  
  const [aadhaar, setAadhaar] = useState(null);
  const [drivingLicense, setDrivingLicense] = useState(null);
  const {data: deliveryPartnerDocs, refetch, isLoading: isLoadingGetDeliveryPartnerDocs } = useGetDeliveryPartnerDocumentsQuery();
  const [uploadDeliveryPartnerDocuments, {isLoading}] = useUploadDeliveryPartnerDocumentsMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!aadhaar) {
      return alert("Please upload Aadhaar");
    } else if (!drivingLicense) {
      return alert("Please upload Driving License");
    }

    const formData = new FormData();
    if (aadhaar) formData.append("aadhaar", aadhaar);
    if (drivingLicense) formData.append("drivingLicense", drivingLicense);

    try {
      const res = await uploadDeliveryPartnerDocuments(formData).unwrap();
      if (res.success) {
        toast.success("Documents successfully uploaded", {autoClose: 1000});
        setAadhaar(null);
        setDrivingLicense(null);
        refetch();
      } else {
        toast.error(res.error || "Documents upload failed", { autoClose: 2000 });
      }
    } catch (err) {
      console.error("Documents upload failed: ", err);
      toast.error("Documents upload failed", {autoClose: 2000});
    }
  }

  const allDocsUploaded = deliveryPartnerDocs?.aadhaar && deliveryPartnerDocs?.drivingLicense;

  return (
    <Form onSubmit={handleSubmit} className="p-3 border rounded-3 bg-light">
      <h4 className="mb-3">Delivery Partner Documents</h4>

      {isLoadingGetDeliveryPartnerDocs ? (
        <div className="text-center my-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
        <Form.Group controlId="aadhaar" className="mb-3">
          <Form.Label>Upload Aadhaar</Form.Label>
          {deliveryPartnerDocs?.aadhaar ? (
            <div className="text-success small">
              <FaCheckCircle className="me-1" /> Provided
            </div>
          ) : (
            <Form.Control
              type="file"
              accept="image/*,application/pdf"
              disabled={isLoading}
              onChange={(e) => setAadhaar(e.target.files[0])}
            />
          )}
        </Form.Group>

        <Form.Group controlId="drivingLicense" className="mb-3">
          <Form.Label>Upload Driving License</Form.Label>
          {deliveryPartnerDocs?.drivingLicense ? (
            <div className="text-success small">
              <FaCheckCircle className="me-1" /> Provided
            </div>
          ) : (
            <Form.Control
              type="file"
              accept="image/*,application/pdf"
              disabled={isLoading}
              onChange={(e) => setDrivingLicense(e.target.files[0])}
          />
          )}
        </Form.Group>

        {!allDocsUploaded &&
        <Button type="submit" disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" /> Uploading...
            </>
          ) : (
            'Upload documents'
          )}
        </Button>
        }
        </>
      )}
    </Form>
  )
}

export default DeliveryPartnerDocumentsScreen;